import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
import { EMPLOYEES_BASE_URL } from '../config';
const initialState = {
  page: 0,
  employees: [],
  total_pages: 0,
  total_results: 0
};
export const useEmployeeListFetch = (id) => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue,setSearchValue] = useState('');
  const [includeInactive,setIncludeInactive] = useState(false)
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
  console.log(id)
  console.log(searchValue)
  const fetchEmployeeList = async(searchValue)=>{
    try {
      setLoading(true);
      setError(false);
     console.log("binne fetchemployeeslist")
      const data = await API.fetchEmployees(searchValue,"",includeInactive,"",accessToken)
     
      console.log(data.employees)
      const employeesWithAvatars = await Promise.all(
        data.employees.map(async (employee) => {
          let avatarUrl = '';

          if (employee.avatar) {
            try {
              const avatarResponse = await fetch(
                `${EMPLOYEES_BASE_URL}${employee.avatar}`,
                { headers: { Authorization: `Bearer ${accessToken}` } }
              );

              if (avatarResponse.ok) {
                const blob = await avatarResponse.blob();
                avatarUrl = URL.createObjectURL(blob); // Correctly set avatar URL
              }
            } catch (avatarError) {
              console.error(`Error fetching avatar for ${employee.name}:`, avatarError);
            }
          }

          return { ...employee, avatarUrl }; // Add avatar URL to employee object
        })
      );
      setState({  
        ...data, employees: employeesWithAvatars
        
      }
      )

      setLoading(false)
      setTrigger(false)

    } catch (error) {
      console.log(error)
      setError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setState(initialState)
    fetchEmployeeList(searchValue)
  },[searchValue,trigger,includeInactive]);

return{state,loading,error,setSearchValue,setIncludeInactive,setLoading,setTrigger};


};
